import { RouteRecordRaw } from "vue-router";
import DeliveryListPage from "@/modules/Store/pages/DeliveryListPage.vue";
import ListPage from "@/modules/Store/pages/StoreListPage.vue";
import StoreExportBlankPage from "@/modules/Store/pages/StoreExportBlankPage.vue";

const storeRoutes: Array<RouteRecordRaw> = [
  {
    path: "/store/delivery",
    component: DeliveryListPage
  },
  {
    path:"/store/list/:type?",
    component:ListPage
  },
  {
    path:"/store/exportblank/:id?",
    name: "store-exportblank",
    component:StoreExportBlankPage,
    props: true,
  }
];

export default storeRoutes;
